// components/LanguageSwitcher/LanguageSwitcher.js

import React, { useState, useEffect } from 'react';
import { FaGlobe } from 'react-icons/fa';
import Flag from 'react-world-flags';
import { useRouter } from 'next/router';

const LanguageSwitcher = ({
  available_locales = [],
  current_locale = null,
}) => {

  const [countryMapping, setCountryMapping] = useState({});
  const router = useRouter();

  useEffect(() => {
    fetch('/language-country-mapping.json')
      .then((res) => res.json())
      .then((data) => setCountryMapping(data))
      .catch((error) =>
        console.error("Error loading language-country mapping:", error)
      );
  }, []);

  const switchLanguage = (languageCode) => {
    const currentPath = router.asPath;

    const newPath =
      currentPath.startsWith('/en') ||
      currentPath.startsWith('/fr') ||
      currentPath.startsWith('/es')
        ? currentPath.replace(/^\/[a-z]{2}/, `/${languageCode}`)
        : `/${languageCode}${currentPath}`;

    router.push(newPath);
  };

  if (!available_locales || available_locales.length <= 1) {
    return null;
  }

  return (
    <div className="header-utility">
      <button
        className="header-utility-button"
        aria-label="Switch language"
      >
        <FaGlobe className="icon-sm" />
      </button>

      <div className="header-utility-dropdown header-utility-dropdown--language">
        <ul className="header-utility-list">
          {available_locales.map((locale) => (
            <li
              key={locale.languageCode}
              className="header-utility-item"
            >
              <button
                onClick={() => switchLanguage(locale.languageCode)}
                className="header-utility-link header-utility-link--language"
              >
                <Flag
                  code={countryMapping[locale.languageCode] || 'us'}
                  className="language-flag"
                />
                <span>
                  {locale.languageCode.toUpperCase()}
                </span>
              </button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default LanguageSwitcher;